import { render, staticRenderFns } from "./SupplierViewSupplierProductsSyncResults.vue?vue&type=template&id=2fefe1ca"
import script from "./SupplierViewSupplierProductsSyncResults.vue?vue&type=script&lang=js"
export * from "./SupplierViewSupplierProductsSyncResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports